import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PolicyAction, PolicyFormValues } from '../policy-dialog';
import z from 'zod';
import { actionPopOptions, enablePopFor } from './policy-field-options';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface ChangePopActionProps {
  setValue: UseFormSetValue<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
}

export const ChangePopActionSchema = z.object({
  type: z.literal('Change_POP'),
  gmailPOPEanbled: z.string(),
  gmailPOPEnabledFor: z.string(),
  gmailPOPAction: z.string(),
});

export type ChangePopActionType = z.infer<typeof ChangePopActionSchema>;

// Type guard to check if an action is ChangeGpanelRoleActionType
function isChangePopAction(
  action: PolicyAction
): action is ChangePopActionType {
  return action.type === 'Change_POP';
}

export default function ChangePopAction({
  setValue,
  watch,
}: ChangePopActionProps) {
  const actionData = watch('actionData');
  const idx = actionData.map((action) => action.type).indexOf('Change_POP');
  const actionAtIndex = actionData[idx];
  if (!isChangePopAction(actionAtIndex)) {
    return null;
  }

  const currentAction: ChangePopActionType = actionAtIndex;

  return (
    <Stack>
      <Stack gap={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={currentAction.gmailPOPEanbled === 'true'}
              onChange={() =>
                setValue(
                  `actionData.${idx}.gmailPOPEanbled`,
                  currentAction.gmailPOPEanbled === 'true' ? 'false' : 'true'
                )
              }
            />
          }
          sx={{ width: 'fit-content' }}
          label="Pop Enabled"
        />
        <TextField
          select
          value={currentAction.gmailPOPEnabledFor}
          disabled={currentAction.gmailPOPEanbled === 'false'}
          onChange={(event) =>
            setValue(`actionData.${idx}.gmailPOPEnabledFor`, event.target.value)
          }
          sx={{ width: 300 }}
        >
          {enablePopFor.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.displayValue}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          value={currentAction.gmailPOPAction}
          disabled={currentAction.gmailPOPEanbled === 'false'}
          onChange={(event) =>
            setValue(`actionData.${idx}.gmailPOPAction`, event.target.value)
          }
          sx={{ width: 300 }}
        >
          {actionPopOptions.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.displayValue}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>
  );
}
